module.exports = __webpack_public_path__ + "img/barcode-light.77a24c09.svg";